import React from 'react';
import { Form, Input, Switch, Select, InputNumber, Divider, Row, Col, Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';

const { Option } = Select;

const AuditOptionsForm = ({ form }) => {
  // 在表单初始化后设置隐藏的默认值
  React.useEffect(() => {
    // 确保这些字段即使不在UI上显示，也会被设置并发送到后端
    form.setFieldsValue({
      is_multi_speaker: true,
      speaker_count: 2
    });
  }, [form]);

  return (
    <Form
      form={form}
      layout="vertical"
      initialValues={{
        language: 'zh',
        is_multi_speaker: true,
        speaker_count: 2,
        translate: false,
        ppt_extraction: false
      }}
    >
      <Divider orientation="left">基本设置</Divider>

      <Row gutter={16}>
        <Col span={24}>
          <Form.Item
            label={
              <span>
                语言 
                <Tooltip title="指定音频的语言类型，仅支持中文、英文、中英文自由说、日文和粤语">
                  <QuestionCircleOutlined style={{ marginLeft: 4 }} />
                </Tooltip>
              </span>
            }
            name="language"
            rules={[{ required: true, message: '请选择语言' }]}
          >
            <Select placeholder="请选择语言">
              <Option value="zh">中文</Option>
              <Option value="en">英文</Option>
              <Option value="fspk">中英文自由说</Option>
              <Option value="ja">日文</Option>
              <Option value="yue">粤语</Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>

      {/* 添加隐藏字段，确保值能被提交 */}
      <Form.Item name="is_multi_speaker" hidden={true}>
        <input type="hidden" />
      </Form.Item>
      
      <Form.Item name="speaker_count" hidden={true}>
        <input type="hidden" />
      </Form.Item>
      
      <Divider orientation="left">PPT提取</Divider>
      <Row gutter={16}>
        <Col span={24}>
          <Form.Item
            label={
              <span>
                提取PPT内容 
                <Tooltip title="启用后，系统将从视频中识别并逐页提取PPT画面">
                  <QuestionCircleOutlined style={{ marginLeft: 4 }} />
                </Tooltip>
              </span>
            }
            name="ppt_extraction"
            valuePropName="checked"
            extra="建议在确认视频画面中存在PPT内容后再启用，以免造成不必要的成本浪费（仅支持视频文件）"
          >
            <Switch checkedChildren="已启用" unCheckedChildren="未启用" />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item
        noStyle
        shouldUpdate={(prevValues, currentValues) => prevValues.language !== currentValues.language}
      >
        {({ getFieldValue }) => {
          const language = getFieldValue('language');
          const canTranslate = language !== 'zh';
          
          return canTranslate ? (
            <div>
              <Divider orientation="left">翻译设置</Divider>
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item
                    label={
                      <span>
                        翻译为中文 
                        <Tooltip title="是否将识别结果翻译为中文，仅在非中文语言时有效">
                          <QuestionCircleOutlined style={{ marginLeft: 4 }} />
                        </Tooltip>
                      </span>
                    }
                    name="translate"
                    valuePropName="checked"
                  >
                    <Switch />
                  </Form.Item>
                </Col>
              </Row>
            </div>
          ) : null;
        }}
      </Form.Item>

      <Divider orientation="left">高级设置</Divider>

      <Form.Item
        label={
          <span>
            自定义参数 
            <Tooltip title="可添加其他通义听悟API支持的参数，JSON格式">
              <QuestionCircleOutlined style={{ marginLeft: 4 }} />
            </Tooltip>
          </span>
        }
        name="custom_params"
      >
        <Input.TextArea
          rows={4}
          placeholder='{"param_name": "value"}'
        />
      </Form.Item>
    </Form>
  );
};

export default AuditOptionsForm; 